/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListEmployeeAIDetectionsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListEmployeeAIDetectionsRequest = {
  /**
   * Canonical enrolled-employee email to list detections for.
   */
  userEmail: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListEmployeeAIDetectionsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListEmployeeAIDetectionsSecurity$outboundSchema: z.ZodMiniType<
  ListEmployeeAIDetectionsSecurity$Outbound,
  ListEmployeeAIDetectionsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listEmployeeAIDetectionsSecurityToJSON(
  listEmployeeAIDetectionsSecurity: ListEmployeeAIDetectionsSecurity,
): string {
  return JSON.stringify(
    ListEmployeeAIDetectionsSecurity$outboundSchema.parse(
      listEmployeeAIDetectionsSecurity,
    ),
  );
}

/** @internal */
export type ListEmployeeAIDetectionsRequest$Outbound = {
  user_email: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListEmployeeAIDetectionsRequest$outboundSchema: z.ZodMiniType<
  ListEmployeeAIDetectionsRequest$Outbound,
  ListEmployeeAIDetectionsRequest
> = z.pipe(
  z.object({
    userEmail: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userEmail: "user_email",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listEmployeeAIDetectionsRequestToJSON(
  listEmployeeAIDetectionsRequest: ListEmployeeAIDetectionsRequest,
): string {
  return JSON.stringify(
    ListEmployeeAIDetectionsRequest$outboundSchema.parse(
      listEmployeeAIDetectionsRequest,
    ),
  );
}
